import { render } from "./AdminMain.vue?vue&type=template&id=3f80de98&scoped=true"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"

import "./AdminMain.vue?vue&type=style&index=0&id=3f80de98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alida\\Desktop\\jupyto\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f80de98"]])

export default __exports__